import { render, staticRenderFns } from "./Agua.vue?vue&type=template&id=43af687b&"
import script from "./Agua.vue?vue&type=script&lang=js&"
export * from "./Agua.vue?vue&type=script&lang=js&"
import style0 from "./Agua.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports